import React, { useEffect, useRef } from 'react';
import { MdPersonAdd, MdStorefront, MdSmartphone, MdCardGiftcard, MdInsights } from 'react-icons/md';
import './HowItWorks.css';

const steps = [
  { icon: <MdPersonAdd />, step: '01', title: 'Customer Registers', desc: 'Customer signs up on the Pointfinity app with their mobile number.' },
  { icon: <MdStorefront />, step: '02', title: 'Visits a Store', desc: 'Customer makes a purchase at any participating store in the network.' },
  { icon: <MdSmartphone />, step: '03', title: 'Store Enters Mobile', desc: 'Store owner enters the customer mobile number at checkout.' },
  { icon: <MdCardGiftcard />, step: '04', title: 'Earns or Redeems Points', desc: 'Customer automatically earns points or chooses to redeem them instantly.' },
  { icon: <MdInsights />, step: '05', title: 'Admin Tracks Revenue', desc: 'Admin views full reports, analytics, and commission data in real time.' },
];

export default function HowItWorks() {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="how-it-works" id="how-it-works" ref={ref}>
      <div className="hiw__bg" />
      <div className="container text-center">
        <span className="section-label reveal">How It Works</span>
        <h2 className="section-title reveal" style={{ transitionDelay: '0.05s' }}>
          From Visit to Reward in Seconds
        </h2>
        <p className="section-subtitle reveal" style={{ transitionDelay: '0.1s' }}>
          A seamless experience for customers, store owners, and admins alike.
        </p>
        <div className="hiw__steps">
          {steps.map((s, i) => (
            <React.Fragment key={s.step}>
              <div className="hiw__step reveal" style={{ transitionDelay: `${0.1 + i * 0.1}s` }}>
                <div className="hiw__step-icon">
                  {s.icon}
                  <span className="hiw__step-num">{s.step}</span>
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
              {i < steps.length - 1 && <div className="hiw__connector" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
